import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { AreaState, UnsavedChangesStore } from './unsaved-changes.types';

import { UnsavedChangesArea } from './unsaved-changes.types';

const createInitialAreaState = (): AreaState => ({
  changeDetectors: [],
});

const createInitialAreas = (): Record<UnsavedChangesArea, AreaState> => {
  const areas = {} as Record<UnsavedChangesArea, AreaState>;

  Object.values(UnsavedChangesArea).forEach((area) => {
    areas[area] = createInitialAreaState();
  });

  return areas;
};

export const useUnsavedChangesStore = create<UnsavedChangesStore>()(
  devtools(
    (set, get) => ({
      areas: createInitialAreas(),

      registerChangeDetector: (area: UnsavedChangesArea, detector: () => boolean) => {
        set((state) => ({
          areas: {
            ...state.areas,
            [area]: {
              ...state.areas[area],
              changeDetectors: [...state.areas[area].changeDetectors, detector],
            },
          },
        }));
      },

      unregisterChangeDetector: (area: UnsavedChangesArea, detector: () => boolean) => {
        set((state) => {
          const remainingDetectors = state.areas[area].changeDetectors.filter((d) => d !== detector);

          return {
            areas: {
              ...state.areas,
              [area]: {
                ...state.areas[area],
                changeDetectors: remainingDetectors,
              },
            },
          };
        });
      },

      checkAreaChanges: (area: UnsavedChangesArea) => {
        const state = get();
        const areaState = state.areas[area];

        const hasChanges = areaState.changeDetectors.some((detector) => detector());

        return hasChanges;
      },

      getAreaState: (area: UnsavedChangesArea) => {
        const state = get();
        return state.areas[area];
      },
    }),
    { name: 'unsaved-changes-store' },
  ),
);
